("use strict");
import { favouritesConstants, fixedDepositsConstants } from "../_constants";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, exhaustMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError } from "../_actions";
import {
  addToFavouritesComplete,
  addToFavouritesError,
  deleteFavouriteComplete,
  deleteFavouriteError,
  favouriteOutStadingAmountComplete,
  favouriteOutStadingAmountError,
  favouriteResendOtpComplete,
  favouriteResendOtpError,
  favouriteTransactionHistoryDetailComplete,
  favouriteTransactionHistoryListComplete,
  favouriteUpdateOtpConfirmationComplete,
  favouriteUpdateOtpConfirmationError,
  getFavouritesDetailsComplete,
  getFavouritesDetailsError,
  getFavouritesListComplete,
  getFavouritesListError,
  getRecentFavouritesListComplete,
  getRecentFavouritesListError,
  payableFavouritesListComplete,
  payableFavouritesListError,
  payFavouriteComplete,
  payFavouriteError,
  updateFavouriteComplete,
  updateFavouriteError,
  validateFavouriteAmountComplete,
  validateFavouriteAmountError,
} from "../_actions/favourites.actions";

export const getFavouritesListEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.GET_FAVOURITES_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/getFavouritesList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            getFavouritesListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(getFavouritesListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const getFavouritesDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_DETAILS_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/getFavouriteDetails",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            getFavouritesDetailsComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(getFavouritesDetailsError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const getRecentFavouritesListEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.GET_RECENT_FAVOURITES_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/getRecentFavouritesList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            getRecentFavouritesListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(getRecentFavouritesListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const addToFavouritesEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.ADD_TO_FAVOURITES_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/addToFavourites",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => addToFavouritesComplete(ajaxResponse.response)),
          catchError((error) =>
            of(addToFavouritesError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const favouritesPayableListEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITES_PAYABLE_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/getFavouritesPayableList",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            payableFavouritesListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(payableFavouritesListError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const validateFavouriteAmountEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.VALIDATE_FAVOURITE_AMOUNT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/validateFavouriteAmount",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            validateFavouriteAmountComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(validateFavouriteAmountError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const favouritePayEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_PAY_BILL_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/favourites/favouritePay",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => payFavouriteComplete(ajaxResponse.response)),
          catchError((error) => of(payFavouriteError(error), ajaxError(error))),
        );
    }),
  );

export const favouriteOutstadingAmountEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_OUTSTANDING_AMOUNT_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/favouriteOutstadingAmount",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            favouriteOutStadingAmountComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(favouriteOutStadingAmountError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const updateFavouriteEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.UPDATE_FAVOURITE_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/updateFavourite",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => updateFavouriteComplete(ajaxResponse.response)),
          catchError((error) =>
            of(updateFavouriteError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const deleteFavouriteEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.DELETE_FAVOURITE_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/favourites/deleteFavourite",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => deleteFavouriteComplete(ajaxResponse.response)),
          catchError((error) =>
            of(deleteFavouriteError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const updateFavouriteOtpConfirmationEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_OTP_CONFIRMATION_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/favourites/favouriteOtpConfrmation",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            favouriteUpdateOtpConfirmationComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(favouriteUpdateOtpConfirmationError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const favouriteResendOtpEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_OTP_RESEND_REQUEST),
    exhaustMap((action) => {
      return ajax
        .post(
          "/api/favourites/otpResend",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            favouriteResendOtpComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(favouriteResendOtpError(error), ajaxError(error)),
          ),
        );
    }),
  );

export const favouriteTransactionHistoryListEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_LIST_REQUEST),
    mergeMap((action) => {
      const { isFiltering, ...payload } = action.payload;

      return ajax
        .post(
          "/api/favourites/favouriteTransactionHistoryList",
          payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return favouriteTransactionHistoryListComplete({
              list: ajaxResponse.response.data?.transactionDtoList,
              isFiltering,
            });
          }),
          catchError((error) => of(ajaxError(error))),
        );
    }),
  );

export const favouriteTransactionHistoryDetailsEpic = (actions$) =>
  actions$.pipe(
    ofType(favouritesConstants.FAVOURITE_TRANSACTION_HISTORY_DETAIL_REQUEST),
    mergeMap((action) => {
      const { ...payload } = action.payload;

      return ajax
        .post(
          "/api/favourites/getFavouriteTransactionDetail",
          payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => {
            return favouriteTransactionHistoryDetailComplete(
              ajaxResponse.response.data.transactionInfo,
            );
          }),
          catchError((error) => of(ajaxError(error))),
        );
    }),
  );
